<template>
  <div class="page">
    <header>
      <div @click="back" tabindex="0" @keypress.space="back" class="back-btn"><i class="fa fa-fw fa-chevron-left"></i></div>
      <div class="view-title">{{ 'CscDetails' | lang }}</div>
    </header>
    <div>
      <csc-contracts :carddata="csc" />
    </div>
    <!-- <footer>
      <button @click="logout">{{ 'logout' | lang }}</button>
    </footer> -->
  </div>
</template>

<script>
import page from '@/mixins/routeControl'
import cscContracts from '@/components/CSCcontracts.vue'

export default {
  name: 'CscContractsPage',
  mixins: [ page ],
  components: { cscContracts },
  props: ['id'],
  data () {
    return {}
  },
  computed: {
    csc () {
      return this.userProfile.tessere.find(t => t.MediaSerialNumber === this.id)
    }
  },
  methods: {
    logout () {
      this.isLogged = false
      this.back()
    }
  },
  beforeDestroy () {},
  mounted () {},
  watch: {}
}
</script>

<style lang="scss">


</style>
